import React from 'react'

const iconWidth = {
    width: "20px",
    height: "20px"
}

const FooterSocialIcons = () => {
  return (
    <ul className="social-icons list-inline">
              <li className="list-inline-item"><a rel="noopener noreferrer" href="https://twitter.com/GetFridayVA" target="_blank"><img loading="lazy" decoding="async" style={iconWidth} src="/assets/images/twitterX.png" alt="icon"/></a></li>
              <li className="list-inline-item"><a rel="noopener noreferrer" href="https://www.facebook.com/GetFriday" target="_blank"><img loading="lazy" decoding="async" style={iconWidth} src="/assets/images/face.png" alt="icon" /></a></li>
              <li className="list-inline-item"><a rel="noopener noreferrer" href="https://www.youtube.com/channel/UCyXzYt0GN5bDPcC-xx4DmKA" target="_blank"><img loading="lazy" decoding="async" style={iconWidth} src="/assets/images/youtube.png" alt="icon" /></a></li>
              <li className="list-inline-item"><a rel="noopener noreferrer" href="https://www.linkedin.com/company/getfriday/mycompany/" target="_blank"><img loading="lazy" decoding="async" style={iconWidth} src="/assets/images/linkedIn.png" alt="icon" /></a></li>
    </ul>
  )
}

export default FooterSocialIcons